// import goldMineImage from "../assets/img/Game 1 The gold mine treasure map.png";
// import skylineImage from "../assets/img/Game 2 Manhattan City Skyline.png";
import wordplayImage from "../assets/img/Game 4 word play make the connection.png";
import TheGreatEscapeImage from "../assets/img/Game 5 the great escape.png";
// import The_Restaurateur from '../assets/img/New-restaurateur.png'
import circuit_Boards from '../assets/img/circuit_Boards.png'
import assembly_line from '../assets/img/assembly_line.png'
import great_escape from '../assets/img/great-escape-2-0.png'
import slideGameVideo from '../assets/videos/Censio slide.mp4'
import matchGameVideo from '../assets/videos/parts-shop_game-trimmed.mp4'
import stackGameVideo from '../assets/videos/Censio stack.mp4'

export const GameStaticData = [
    // { gamename: "The Gold Mine Treasure Map", idGame: 1, gamecompleted: 0, gameImage: goldMineImage, GameLink: `${process.env.REACT_APP_GAMES_URL}/CensioGMT/?token=`, gameVideoLink: `${process.env.REACT_APP_S3_BUCKET_URL}/assets/img/Game1.mp4` },
    // { gamename: "Skyline", idGame: 2, gamecompleted: 0, gameImage: skylineImage, GameLink: `${process.env.REACT_APP_GAMES_URL}/CensioMC/?token=`, gameVideoLink: `${process.env.REACT_APP_S3_BUCKET_URL}/assets/img/Game2.mp4` },
    // { gamename: "The Restaurateur", idGame: 3, gamecompleted: 0, gameImage: The_Restaurateur, GameLink: `${process.env.REACT_APP_GAMES_URL}/TheRestaurant/?token=`, gameVideoLink: `${process.env.REACT_APP_S3_BUCKET_URL}/assets/img/Game3.mp4` },
    {
        gamename: "Circuit Boards",
        idGame: 6,
        gamecompleted: 0,
        gameImage: circuit_Boards,
        GameLink: `${process.env.REACT_APP_GAMES_URL}/CensioSlide/?token=`,
        gameVideoLink: slideGameVideo,
        gameDescription: `Welcome to the Robot Factory! Let’s kick things off by assembling some circuit boards for the robots. Build as many as you can—no pressure, just infinite robots depending on it.`
    },
    {
        gamename: "Parts Shop",
        idGame: 7,
        gamecompleted: 0,
        gameImage: great_escape,
        GameLink: `${process.env.REACT_APP_GAMES_URL}/CensioMatch/?token=`,
        gameVideoLink: matchGameVideo,
        gameDescription: `Use essential hardware like screws, bolts, and nuts to assemble the robot's physical components. The more parts you build, the more robots you can bring to life!`
    },
    {
        gamename: "Assembly Line",
        idGame: 8,
        gamecompleted: 0,
        gameImage: assembly_line,
        GameLink: `${process.env.REACT_APP_GAMES_URL}/CensioStack/?token=`,
        gameVideoLink: stackGameVideo,
        gameDescription: `Pack the robots carefully for shipment to customers. Remember, robots are fragile, so handle them with care.`

    },
    {
        gamename: "Wordplay",
        idGame: 4,
        gamecompleted: 0,
        gameImage: wordplayImage,
        GameLink: `${process.env.REACT_APP_GAMES_URL}/Censiowordplay/?token=`,
        gameVideoLink: `${process.env.REACT_APP_S3_BUCKET_URL}/assets/img/Game4.mp4`,
        gameDescription: `Let’s play a word soup game! Come up with as many words as you can on your own—the more creative and unique, the better!`
    },
    // {
    //     gamename: "The Great Escape",
    //     idGame: 5,
    //     gamecompleted: 0,
    //     gameImage: TheGreatEscapeImage,
    //     GameLink: `${process.env.REACT_APP_GAMES_URL}/thegreatescape/?token=`,
    //     gameVideoLink: `${process.env.REACT_APP_S3_BUCKET_URL}/assets/img/Game5.mp4`,
    //     gameDescription: `Are you ready for a thrilling challenge? Get set to escape the room by shifting objects, outsmarting the guards, and navigating obstacles that will put your wits and creativity to the test. Let the adventure begin!`
    // },
]
